import moment from 'moment';
import { useSelector } from 'react-redux';
import StyledDiv from 'components/styled/StyledDiv';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { displayAmount } from 'shared/helpers/common';

export default function OutstandingBalance() {
  const booking = useSelector((state) => state.ui.selectedBooking);
  const { balanceDueDate, paid, due, currentPrice, currency } = booking;
  const toBePaidAmount = due && currency ? displayAmount(due, currency) : null;
  const dateFormat = 'DD MMMM yyyy';
  const paidPercentage = Math.round((paid / currentPrice) * 100);

  const { whiteLabelSettings: { primaryColour, secondaryColour } = {} } =
    useWhiteLabelSettings();

  const customStyles = `
    border-radius: 0.5rem;
    background-color: ${secondaryColour || '#072636'};
    margin-top: 25px;
    color: ${primaryColour || '#FFF'};

    .meter { 
      height: 5px;
      position: relative;
      background: #FFF;
      border-radius: 5px;
    }

    .meter > span {
      display: block;
      height: 100%;
      background-color: ${primaryColour || '#18A8CB'};
      border-radius: 5px;
      position: relative;
      overflow: hidden;
    }

    @media (min-width: 1024px) {
      div.outstanding-balance {
        height: 12rem;
        margin: auto;
      }
    }
  `;

  return (
    <StyledDiv customStyles={customStyles}>
      <div className="p-5 outstanding-balance">
        <div className="xs:text-center lg:text-left">
          <div className="font-medium text-[24px]">
            {toBePaidAmount && (
              <div className="font-medium text-[24px]">
                {toBePaidAmount} to be paid
              </div>
            )}
          </div>
          <div className="mt-3 font-medium">
            {balanceDueDate && `Due date: ${moment(balanceDueDate).format(dateFormat)}`}
          </div>
          <div className="meter mt-3">
            <span
              style={{
                width: `${paidPercentage}%`,
              }}
            />
          </div>
          {(due === 0 || due) && (paid === 0 || paid) && currency && (
            <div className="mt-3 font-normal">
              {due === 0
                ? 'Payment complete'
                : `${
                    displayAmount(paid, currency) === '-'
                      ? displayAmount(0, currency)
                      : displayAmount(paid, currency)
                  } paid so far`}
            </div>
          )}
        </div>
      </div>
    </StyledDiv>
  );
}
